<template>
    <div>
        <swb-bid-enroll-search class="mt10" @showSearch="showSearch"></swb-bid-enroll-search>

        <div class="tab-container small base mt10 mb10">
            <div class="tabs-nav">
                <ul class="head">
                    <li v-for="(text, value) in enrollStateList" :class="{'current': value == checkStateValue}" class="head-item" @click="tabChange(value)">
                        <span>{{text}}</span>
                    </li>
                </ul>
            </div>
        </div>

        <table class="custom-tbl" v-if="checkStateValue==0">
            <thead class="head">
            <tr class="row">
                <th style="text-align: left">标题</th>
                <th width="200" style="text-align: left">招标方名称</th>
                <th width="150">开标时间</th>
                <th width="200" style="text-align: left">申请人</th>
                <th width="170">报名时间</th>
                <th width="80">状态</th>
                <th width="200" style="text-align: left">审核描述</th>
                <th width="250" style="text-align: left">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="bidEnroll in bidEnrollList">
                <td style="text-align: left">{{bidEnroll.title}}</td>
                <td style="text-align: left">{{bidEnroll.fstPartyName}}</td>
                <td>{{bidEnroll.enrollCloseTime}}</td>
                <td>
                    <span v-if="bidEnroll.applyState!=0" style="text-align: left">{{bidEnroll.applicantName}}</span>
                </td>
                <td>
                    <span v-if="bidEnroll.applyState!=0">{{bidEnroll.applyTime}}</span>
                    <span v-if="bidEnroll.applyState==0">{{bidEnroll.createTime}}</span>
                </td>
                <td class="align-left">
                    <span v-if="bidEnroll.applyState == 0 && bidEnroll.auditState==0">待申请</span>
                    <span v-if="bidEnroll.applyState == 1 && bidEnroll.auditState==0">待审核</span>
                    <span v-if="bidEnroll.applyState == 2 && bidEnroll.auditState==1">通过</span>
                    <span v-if="bidEnroll.auditState == -1">未通过</span>
                </td>
                <td class="ellipsis-1" style="text-align: left" :title="bidEnroll.auditDesc">{{bidEnroll.auditDesc}}</td>
                <td style="text-align: left">
                    <div>
                        <div>
                            <a class="swb-btn swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(bidEnroll.callDocId)">
                                查看招标书公告</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_enroll')" @click="toBidEnrollInfo(bidEnroll.id)">报名信息</a>
                            <a class="swb-btn-link" v-if="checkActionPerm('view_audit_rec')" @click="getBidDocAuditRecs(bidEnroll.id)">审核记录</a>
                            <a class="swb-btn swb-btn-link" v-if="checkActionPerm('view_bid')" @click="toCallBidDocInfo(bidEnroll.callDocId,bidEnroll.resultFlag,bidEnroll.openTime)">标书信息</a>
                            <a class="swb-btn swb-btn-link" v-if="bidEnroll.auditState !=1 && bidEnroll.applyState != 1 && checkActionPerm('apply')" @click="ApplyBidEnroll(bidEnroll.id)">申请审核</a>
                            <a class="swb-btn swb-btn-link" v-if="bidEnroll.auditState ==0 && bidEnroll.applyState == 1 && postId == bidEnroll.auditorPostId && checkActionPerm('audit')" @click="callBidDocAudit(bidEnroll.id)">审核</a>
                            <a class="swb-btn swb-btn-link" v-if="bidEnroll.auditState !=1 && bidEnroll.applyState != 1 && checkActionPerm('modify')" @click="toBidEnrollsignUp(bidEnroll.id,bidEnroll.callDocId)">修改</a>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>

        <table class="custom-tbl" v-if="checkStateValue==1">
            <thead class="head">
            <tr class="row">
                <th style="text-align: left">标题</th>
                <th width="200" style="text-align: left">招标方名称</th>
                <th width="150">开标时间</th>
                <th width="200" style="text-align: left">申请人</th>
                <th width="170">报名时间</th>
                <th width="80">状态</th>
                <th width="200" style="text-align: left">审核描述</th>
                <th width="250" style="text-align: left">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="bidEnroll in bidEnrollList">
                <td style="text-align: left">{{bidEnroll.title}}</td>
                <td style="text-align: left">{{bidEnroll.fstPartyName}}</td>
                <td>{{bidEnroll.resultPublishTime}}</td>
                <td style="text-align: left">{{bidEnroll.applicantName}}</td>
                <td>{{bidEnroll.auditTime}}</td>

                <td>
                    <span v-if="!checkTime(bidEnroll.openTime)">待预审结果</span>
                    <span v-if="bidEnroll.resultFlag==1 && checkTime(bidEnroll.openTime)">通过</span>
                    <span v-if="bidEnroll.resultFlag == -1 && checkTime(bidEnroll.openTime)">未通过</span>
                </td>
                <td class="ellipsis-1" style="text-align: left" :title="bidEnroll.auditDesc">{{bidEnroll.auditDesc}}</td>
                <td style="text-align: left">
                    <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(bidEnroll.callDocId)"> 查看招标书公告</a>
                    <a class="swb-btn-link" v-if="checkActionPerm('view_enroll')" @click="toBidEnrollInfo(bidEnroll.id)">报名信息</a>
                    <a class="swb-btn-link" v-if="checkActionPerm('view_audit_rec')" @click="getBidDocAuditRecs(bidEnroll.id)">审核记录</a>
                    <a class="swb-btn-link" v-if="checkActionPerm('view_bid')" @click="toCallBidDocInfo(bidEnroll.callDocId,bidEnroll.resultFlag,bidEnroll.openTime)">标书信息</a>
                    <a class="swb-btn-link" v-if="bidEnroll.resultFlag == 1 && checkTime(bidEnroll.openTime)  && bidEnroll.tendAllowed && bidEnroll.isBid==false && callBidResultFlag == 'Initial' && checkActionPerm('enlist')" @click="bidDocJudge(bidEnroll.callDocId,bidEnroll.id)">参与投标</a>
                </td>
            </tr>
            </tbody>
        </table>
        <div class="pagination-layout mt10">
            <el-pagination background class="pagination-layout mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils} from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import tendBidApi from '../../api/tendBid'
    import userApi from '../../api/user'

    import SwbCallBidDocInfo from './CallBidDocInfo';
    Routes.add(SwbCallBidDocInfo);

    import SwbBidEnrollAudit from './BidEnrollAudit';
    Vue.regist(SwbBidEnrollAudit);

    import SwbBidEnrollInfo from './BidEnrollInfo';
    Routes.add(SwbBidEnrollInfo);

    import SwbSaveBidDoc from './SaveBidDoc';
    Routes.add(SwbSaveBidDoc);

    import SwbCallBidApply from './CallBidApply';
    Vue.regist(SwbCallBidApply);

    import { showComAuditorSelectDlg } from '../merchant/showSelectDlg'

    import { getDefaultPageSizes } from '../../app.conf';
    import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
    import { showBizAuditDlg } from '../merchant/showSelectDlg'

    import { checkUserActionPerm } from '../index'

    import SwbCallBidNoticeList from './CallBidNoticeList';
    Vue.regist(SwbCallBidNoticeList);

    import SwbBidEnrollAuditRecList from './BidEnrollAuditRecList';
    Vue.regist(SwbBidEnrollAuditRecList);

    import SwbBidEnrollSignUp from './BidEnrollSignUp';
    Routes.add(SwbBidEnrollSignUp);

    import SwbBidEnrollSearchLet from './BidEnrollSearchLet';
    Vue.regist(SwbBidEnrollSearchLet);

    export default{
        name: 'swb-bid-enroll-list',
        path: '/tend/bid/enroll/list',
        pathOld: '/bid/enroll/list',
        avlActions: 'view_notice|view_enroll|view_audit_rec|view_bid|enlist|next_apply|audit|modify|apply',
        avlActionNames: '查看招标书公告、报名信息、审核记录、标书信息、修改、申请审核、审核、参与投标、',
        avlScopes: 'servicer',
        desc: '投标报名列表',
        helpArticleCode: 'servicer-tend-bid-enroll-list',
        data: function () {
            return {
                //分页信息
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                callBidResultFlag: null,
                //
                bidEnrollList: [],
                postId: null,
                userInfo: null,
                enrollStateList: [],
                checkStateValue: 0,
            }
        },
        created: function () {
            let self = this;
            //----------------------分页--------------------------------
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            // --------------------查询--------------------------------
            self.enrollStateList = getEnumMap('enrollState', 'value2text');
            self.callBidResultFlag = getEnumInfoWith('callBidResultFlag');
            self.userCurrentInfo();
            let checkState = this.$route.query.checkState || null;
            if(checkState != null) {
                this.getBidEnrollList(checkState);
            } else {
                this.getBidEnrollList(0);
            }
        },
        methods: {
            showSearch: function (data) {
                this.queryModel = data;
                this.pageNumber = 1;
                this.getBidEnrollList(this.checkStateValue);
            },

            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            tabChange: function (val) {
                this.pageNumber = 1;
                this.getBidEnrollList(val);
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getBidEnrollList(this.checkStateValue);
            },

            searchTag: function (tag) {
                this.sndPartyFlag = tag;
                this.searchShow = true;
                this.getBidEnrollList(this.checkStateValue);
            },

            getBidEnrollList: function (value) {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                self.checkStateValue = value;
                // 报名状态的枚举
                let applyList = getEnumMap('applyState', 'value2text');
                let auditList = getEnumMap('auditState', 'value2text');
                let resultFlagList = getEnumMap('bidEnrollResultFlag', 'value2text');
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);

                filterItems.checkStateValue = value;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                tendBidApi.getBidEnrollList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let bidEnrollList = result.data.rows;
                        for(let i = 0; i < bidEnrollList.length; i++) {
                            let bidEnroll = bidEnrollList[i];
                            self.callBidResultFlag = getEnumInfoWith('callBidResultFlag', 'value', bidEnroll.callBidSuccess).name;
                        }
                        self.bidEnrollList = bidEnrollList;
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            toBidEnrollsignUp: function (id, callDocId) {
                this.$router.push({
                    path: SwbBidEnrollSignUp.path,
                    query: {
                        id: id,
                        callDocId: callDocId
                    }
                });
            },

            userCurrentInfo: function () {   // 当前登录信息
                let self = this;
                let data = {};
                userApi.getUserInfoByContext(data, function (result) {
                    if(result.type === "info") {
                        let userInfo = result.data;
                        self.postId = userInfo.scopeEntity.postId;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            // 申请报名
            ApplyBidEnroll: function (enrollId) {

                let self = this;
                //
                showComActionPostSelectDlg({
                    rescUrl: Vue.$getClassInfo(this).path,
                    action: 'audit',
                    //auditorId : null //初始 auditorId
                }, function (resultData) {
                    resultData = resultData || {};
                    if(resultData.postId == null) {
                        Toast.show('请选 择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    let postData = {
                        id: enrollId,
                        //
                        auditorPostId: resultData.postId,
                        //
                        applyDesc: resultData.applyDesc
                    };

                    tendBidApi.applyBidEnroll(postData, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('申请成功');
                            //
                            self.getBidEnrollList(0);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, this);

            },

            // 审核
            callBidDocAudit: function (id) {
                let self = this;

                showBizAuditDlg({
                    title: "报名 - 审核",
                    nextPostParams: {
                        rescUrl: Vue.$getClassInfo(self).path,
                        action: 'audit',
                    }
                }, function (resultData) {
                    resultData = resultData || {};
                    let nextPostResultData = resultData.nextPostResultData || null;
                    let auditorPostId = null;
                    if(nextPostResultData != null) {
                        auditorPostId = nextPostResultData.postId;
                    }
                    let postData = {
                        id: id,
                        auditState: resultData.auditState,
                        auditDesc: resultData.auditDesc,
                        auditorPostId: auditorPostId,
                    };
                    tendBidApi.auditBidEnroll(postData, function (result) {
                        if(result.type == 'info') {
                            self.getBidEnrollList(0);
                            MsgBox.success('操作成功');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, this);
            },

            // 审核记录
            getBidDocAuditRecs: function (id) {
                Vue.$showDialog({
                    title: "审核记录",
                    template: '<div><swb-bid-enroll-audit-rec-list :id="id" :type="enroll" ref="swb_bid_enroll_audit_rec_list"></swb-bid-enroll-audit-rec-list>' +
                    '</div>',
                    data: {
                        loading: false,
                        id: id,
                        enroll: 'enroll'
                    },
                });
            },

            //跳转招标书详细信息界面
            toCallBidDocInfo: function (callBidDocId, resultFlag, openTime) {
                let flag;
                if(resultFlag == 1) {
                    flag = true;
                } else {
                    flag = false;
                }
                this.$router.push({
                    path: SwbCallBidDocInfo.path,
                    query: {
                        callBidDocId: callBidDocId,
                        flag: flag,
                        openTime: openTime,
                        hisUrl: '/bid/enroll/list',
                        checkState: this.checkStateValue
                    }
                });
            },
            // 跳转报名详细信息界面
            toBidEnrollInfo: function (bidEnrollId) {
                this.$router.push({
                    path: SwbBidEnrollInfo.path,
                    query: {
                        bidEnrollId: bidEnrollId,
                        checkState: this.checkStateValue
                    }
                });
            }
            ,
            // 检查是否已经投标
            bidDocJudge: function (callDocId, bidEnrollId) {
                let self = this;
                let postData = {};
                postData.callDocId = callDocId;
                tendBidApi.getBidDocCheckResult(postData, function (result) {
                    if(result.type == 'info') {
                        self.toSaveBidDoc(callDocId, bidEnrollId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 参与投标
            toSaveBidDoc: function (docId, bidEnrollId) {
                this.$router.push({
                    path: SwbSaveBidDoc.path,
                    query: {
                        callBidDocId: docId,
                        bidEnrollId: bidEnrollId,
                    }
                });
            },

            lookNotice: function (content) {
                let self = this;
                Vue.$showDialog({
                    title: '查看 - 公告',
                    showCloseBtn: true,
                    width: 1200,
                    height: 900,
                    template: '<div>' +
                    '<swb-ck-editor ref="theCkEditor" :content="content"></swb-ck-editor>' +
                    '</div>',
                    data: {
                        content: null,
                    },
                    okClicked: function () {
                    },
                    okVisible: false,
                    method: {},
                    lifecycle: {
                        created: function () {
                            this.content = content;
                        }
                    }
                });
            },

            getCallBidNoticeByCallBidDocId: function (id) {
                let self = this;
                Vue.$showDialog({
                    title: '公告列表 - 查看',
                    showCloseBtn: true,
                    width: 900,
                    height: 700,
                    template: '<div>' +
                    '<swb-call-bid-notice-list :docId="docId" ref="swb_call_Bid_notice_list"></swb-call-bid-notice-list>' +
                    '</div>',
                    data: {
                        docId: id,
                    },
                    okClicked: function () {
                    },
                    okVisible: false,
                    method: {},
                    lifecycle: {}

                });
            },

            checkTime: function (time) {
                var currTime = new Date();
                var dbTime = new Date(time);
                if(currTime.getTime() >= dbTime.getTime()) {
                    return true;
                } else if(currTime.getTime() < dbTime.getTime()) {
                    return false;
                }
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/BidEnrollList.vue